<mat-progress-bar
	mode="indeterminate"
	*ngIf="!isDataLoaded"
	class="sdp-progress-bar"
></mat-progress-bar>
<h2>
	{{ "assignApplications.title" | translate }}
</h2>
<div class="sdp-section-header-description">
	<div class="sdp-section-header-description">
		{{ "policies.info" | translate }}
	</div>
	<div class="sdp-button-create-container-no-card">
		<button
			mat-raised-button
			color="primary"
			(click)="showCreatePolicy()"
			class="sdp-button-create"
		>{{ "sdp.label.add" | translate }}</button>
	</div>
</div>
<div class="sdp-clear"></div>
<div>
	<mat-card class="sdp-administrative-table-card">
		<sdp-generic-table
			[columnSchema]="columnSchema"
			[tableName]="'Policies'"
			[tableData]="data"
			[rows]="10"
		></sdp-generic-table>
	</mat-card>
</div>
<router-outlet></router-outlet>